import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetAmbarListPagingAndFilterRequest {
    searchTerm: string
    skip?: number
    take?: number
    columnChooser: ColumnChooserModel[] | undefined
    currentPage: number
    sortColumn?: string
    sortDirection?: string
    selectedSenderCustomer?: CustomSingleSelectModel | undefined
    selectedCustomer?: CustomSingleSelectModel | undefined
    selectedReceiverCustomer?: CustomSingleSelectModel | undefined
    selectedDivision?: CustomSingleSelectModel | undefined
    selectedPo?: CustomSingleSelectModel | undefined
    ids?: string[]
    ambarVoyageRefNo?: string
    orderDateStart?: string
    orderDateEnd?: string
    loadDateStart?: string
    loadDateEnd?: string
    ambarVoyageStartDateStart?: string
    ambarVoyageStartDateEnd?: string
    isExpectedIncomeEmpty: boolean
    isExpectedOutcomeEmpty: boolean
    selectedCarryMethod?: CustomSingleSelectModel | undefined
    selectedCarryType?: CustomSingleSelectModel | undefined
    selectedVehicle?: CustomSingleSelectModel | undefined
    selectedTrailer?: CustomSingleSelectModel | undefined
    selectedDriver?: CustomSingleSelectModel | undefined
    selectedLoadingCounty?: CustomSingleSelectModel | undefined
    selectedLoadingDistrict?: CustomSingleSelectModel | undefined
    selectedLoadingNeighborhood?: CustomSingleSelectModel | undefined
    selectedLoadingRegion?: CustomSingleSelectModel | undefined
    selectedDeliverCounty?: CustomSingleSelectModel | undefined
    selectedDeliverDistrict?: CustomSingleSelectModel | undefined
    selectedDeliverNeighborhood?: CustomSingleSelectModel | undefined
    selectedDeliverRegion?: CustomSingleSelectModel | undefined
    columnFilters: ColumnFilterModel[]
}

export const initialGetAmbarListPagingAndFilterRequest: GetAmbarListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    columnChooser: undefined,
    sortColumn: undefined,
    sortDirection: undefined,
    isExpectedIncomeEmpty: false,
    isExpectedOutcomeEmpty: false,
    columnFilters: []
}